import booleanPointInPolygon from '@turf/boolean-point-in-polygon';
import type { MapPin } from '@ooh/ui/components/map-view';

const isPointInPolygon = booleanPointInPolygon as (
  point: GeoJSON.Feature<GeoJSON.Point>,
  polygon: GeoJSON.Polygon,
) => boolean;

/**
 * Returns the ids of pins whose coordinates fall inside the given polygon.
 * Operates entirely client-side against the loaded pin set.
 */
export function getPinsInsideShape(pins: MapPin[], geometry: GeoJSON.Polygon): (string | number)[] {
  return pins
    .filter((pin) =>
      isPointInPolygon(
        {
          type: 'Feature',
          geometry: { type: 'Point', coordinates: [pin.longitude, pin.latitude] },
          properties: {},
        },
        geometry,
      ),
    )
    .map((pin) => pin.id);
}
